import { apiUrl } from '../../config'

export const campaignsUrl = `${apiUrl}/campaign?forms=1`

export const getFormsUrl = (splitId) => `${apiUrl}/forms/${splitId}`

export const getCampaignDownloadUrl = (campaignId) => `${apiUrl}/campaign/${campaignId}/form/download`
